<app-update-bar></app-update-bar>
<router-outlet></router-outlet>
